import React from 'react'
import { Avatar } from '@chakra-ui/react'
import { Icon } from '@chakra-ui/icons'
import { Circle, SquareProps } from '@chakra-ui/react'

import { speciesIconMap } from '~config/constants'
import { PatientFieldsFragment, Species } from '~graphql/generated/graphql'

interface Props extends SquareProps {
    patient?: {
        avatar_url?: string | null
        clinic_species?: {
            species: Species
        } | null
    } | null
}

export default function SpeciesIcon({ patient, ...props }: Props) {
    if (patient?.avatar_url) {
        return <Avatar src={patient.avatar_url} name={''} size="md" />
    }

    return (
        <Circle bg="brand.100" size={12} p={2} {...props}>
            <Icon
                as={
                    speciesIconMap[
                        patient?.clinic_species?.species || Species.Other
                    ]
                }
                color="brand.800"
                w="full"
                h="full"
            />
        </Circle>
    )
}
